import { useIntl } from 'react-intl'
import { AnyObjectSchema, object, string } from 'yup'

export interface MfaValues {
  authenticationCode: string
}

const initialValues: MfaValues = {
  authenticationCode: '',
}

export const useMfaValidators = (): {
  initialValues: MfaValues
  validationSchema: AnyObjectSchema
} => {
  const intl = useIntl()

  const codeMfaInvalidDigit = intl.formatMessage({
    id: 'sign_in.form.mfa_invalid_digit',
  })

  const validationSchema = object({
    authenticationCode: string().matches(/^\d{6}$/, codeMfaInvalidDigit),
  })

  return {
    initialValues,
    validationSchema,
  }
}
